import { ToolkitPropertyEnum, isDefined, isNull } from '@aloft/toolkit-shared';

import { getColorForStatusOrSubject } from '../../../utils/getColorForStatusOrSubject.ts';
import { parseReferenceViewID } from '../index.ts';
import { useMapCoords } from './useMapCoords.ts';

function getMapDataID(propertyID?: string) {
  const parsedID = isDefined(propertyID) ? parseReferenceViewID(propertyID) : null;
  if (!isNull(parsedID) && 'type' in parsedID) {
    return parsedID.type === 'subject' ? 'subject' : parsedID.compID;
  }
  return propertyID;
}

export function useMlsStatusPinColor(propertyID?: string) {
  const mapData = useMapCoords();
  const mapDataID = getMapDataID(propertyID);

  const listingStatus = isDefined(mapDataID)
    ? (mapData.results[mapDataID]?.mlsStatus as ToolkitPropertyEnum<'ListingStatusType'>)
    : undefined;

  return getColorForStatusOrSubject(mapDataID === 'subject' ? 'Subject' : listingStatus);
}
